import React from "react";
import { PageType } from "core/types";
import { config } from "core/utils";
import { Meta } from "app/Meta";
export var PageMeta = function (_a) {
    var origin = _a.origin, page = _a.page;
    var title = page.title, slug = page.slug, description = page.description, type = page.type, image = page.image;
    var imageUrl = image.small.webp;
    var url = config.urls.absoluteUrl(origin, slug);
    return (React.createElement(Meta, { data: {
            pageTitle: getTitle(page),
            title: title,
            description: description || undefined,
            imageUrl: imageUrl,
            url: url,
            ogType: getOgType(type),
            program: getProgram(page),
            type: type,
        } }));
};
function getProgram(page) {
    var _a;
    switch (page.__typename) {
        case PageType.Article:
        case PageType.BasicPage:
        case PageType.Contest:
        case PageType.Participate:
        case PageType.Interactive:
        case PageType.Video:
            return (_a = page.program) === null || _a === void 0 ? void 0 : _a.title;
        default:
            return undefined;
    }
}
function getTitle(_a) {
    var title = _a.title;
    return title;
}
function getOgType(type) {
    switch (type) {
        case PageType.HomePage:
        case PageType.ProgramOverview:
        case PageType.TicketOverview:
            return "website";
        case PageType.Article:
        case PageType.BasicPage:
        case PageType.Contest:
        case PageType.Participate:
        case PageType.Interactive:
            return "article";
        case PageType.Video:
            return "video.episode";
        case PageType.Program:
            return "video.tv_show";
    }
}
